<template>
  <div class="app">
    <application-header class="header" />
    <div class="main">
      <router-view />
    </div>
    <application-footer v-if="!isRenaultEvent()" class="footer" />
  </div>
</template>

<script>
import ApplicationHeader from './application-header.vue'
import ApplicationFooter from './application-footer.vue'

export default {
  name: 'main-navigator',
  components: {
    ApplicationHeader,
    ApplicationFooter,
  },
  methods: {
    isRenaultEvent() {
      return window.location.href.includes('convention-in-dubrovnik-5f3d')
    },
  },
}
</script>

<style scoped>
.app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  position: -webkit-sticky;
  position: sticky;
  z-index: 100;
  top: 0;
}

.main {
  flex-grow: 1;
}

@media only screen and (max-width: 800px) {
  .main {
    margin: 0 1.5rem;
  }
}

.footer {
  margin-top: 3rem;
}
</style>
